//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.ExpressionDouble.js";
let d=[[[0,"ApproachFlag",1,0],[0,"ClearanceDistance",1,0],[0,"CollisionFlag",1,0],[0,"ReturnFlag",1,0],[0,"StandoffDistance",1,0],[1,"StandoffDistanceBuilder",0,"CAM.ExpressionDouble",0]],[],[]];
SPLM.CAM.ProbeProtectedParametersBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ProbeProtectedParametersBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ProbeProtectedParametersBuilder.CollisionFlagTypes = Object.freeze({
    "Alarm" : "Alarm", "Flag" : "Flag"});

SPLM.CAM.ProbeProtectedParametersBuilder.AppMethodTypes = Object.freeze({
    "None" : "None", "Clearance" : "Clearance", "Direct" : "Direct", "RadialAxial" : "RadialAxial", "AxialRadial" : "AxialRadial", "RadialAxialWithClearance" : "RadialAxialWithClearance", "AxialRadialWithClearance" : "AxialRadialWithClearance"});

SPLM.CAM.ProbeProtectedParametersBuilder.DepMethodTypes = Object.freeze({
    "None" : "None", "Clearance" : "Clearance"});

export default SPLM;